import { RowLayoutRenderer, rowLayoutTester } from './RowLayout';

export default [{ tester: rowLayoutTester, renderer: RowLayoutRenderer }];
